import { Package } from "lucide-react";
import { cn } from "@bcc/lib/utils";
import {
  setDialogHeaderContentTestId,
  setDialogHeaderContentIconTestId,
  setDialogHeaderContentTitleTestId,
  setDialogHeaderContentDescriptionTestId,
} from "./dialog-header-content.utils";

export interface DialogHeaderContentProps {
  title: string;
  description: string;
  testId?: string;
  className?: string;
}

export function DialogHeaderContent({ title, description, testId, className }: DialogHeaderContentProps) {
  return (
    <div data-testid={testId ?? setDialogHeaderContentTestId("default")} className={cn("flex items-center gap-3 mb-2", className)}>
      <div
        data-testid={setDialogHeaderContentIconTestId("default")}
        className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary/10"
      >
        <Package className="h-5 w-5 text-primary" />
      </div>
      <div>
        <h2 data-testid={setDialogHeaderContentTitleTestId("default")} className="text-lg font-semibold">
          {title}
        </h2>
        <p data-testid={setDialogHeaderContentDescriptionTestId("default")} className="text-sm text-muted-foreground">
          {description}
        </p>
      </div>
    </div>
  );
}
